import { useState } from 'react';
import { Calendar, ChevronDown, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { 
  downloadICS, 
  getGoogleCalendarUrl, 
  getOutlookCalendarUrl 
} from '@/utils/calendarUtils';

/**
 * AddToCalendarButton Component
 * Dropdown button to add events to various calendar services
 */
const AddToCalendarButton = ({ event, variant = 'outline', size = 'sm', className = '' }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleGoogleCalendar = () => {
    const url = getGoogleCalendarUrl(event);
    window.open(url, '_blank');
    setIsOpen(false);
  };

  const handleOutlookCalendar = () => {
    const url = getOutlookCalendarUrl(event);
    window.open(url, '_blank');
    setIsOpen(false);
  };

  const handleDownloadICS = () => {
    downloadICS(event);
    setIsOpen(false);
  };

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button variant={variant} size={size} className={className}>
          <Calendar className="w-4 h-4 mr-2" />
          Add to Calendar
          <ChevronDown className="w-4 h-4 ml-2" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuItem onClick={handleGoogleCalendar} className="cursor-pointer">
          <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          Google Calendar
        </DropdownMenuItem>
        
        <DropdownMenuItem onClick={handleOutlookCalendar} className="cursor-pointer">
          <svg className="w-4 h-4 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.5 3v18h7.5V3h-7.5z" fill="#0078D4"/>
            <path d="M3 9.75v9h10.5V3H6.75C4.68 3 3 4.68 3 6.75v3z" fill="#0078D4" opacity="0.8"/>
            <path d="M13.5 9.75h7.5V3h-7.5v6.75z" fill="#50E6FF"/>
            <path d="M13.5 16.5h7.5V9.75h-7.5V16.5z" fill="#0078D4"/>
          </svg>
          Outlook Calendar
        </DropdownMenuItem>
        
        <DropdownMenuItem onClick={handleDownloadICS} className="cursor-pointer">
          <Download className="w-4 h-4 mr-2" />
          Download .ICS (Apple/Other)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AddToCalendarButton;
